// this is an autogenerated file from App/Widget/Content/Questions/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Widget_Content_Questions(
  $person: lead_submit_person!
  $responsible: lead_submit_responsible
  $insurance: MedicalPlan
  $appointment: jsonb
  $location: jsonb
  $images: jsonb
  $answers: jsonb
) {
  leads_submit(
    person: $person
    responsible: $responsible
    insurance: $insurance
    appointment: $appointment
    location: $location
    images: $images
    answers: $answers
  ) {
    ok
  }
}

`